export default __webpack_public_path__ + "static/media/user.cdcc604d.svg";